module.exports = __webpack_public_path__ + "img/74.0b52f56d.jpg";